import * as noUiSlider from  'nouislider';
import camelCase from 'lodash/camelCase';

export default class RangeSlider {
	constructor(params) {
		this.params = params;
		this.root = document.querySelector(this.params.root);
	}
	init(onUpdateCallback) {
		if (!this.root) return false;
		this.data = JSON.parse(this.root.dataset[camelCase(this.params.root.replace('data', ''))])
		this._initRangeSlider();
	}
	
	_initRangeSlider() {
		console.log(this.data);
		this.slider = noUiSlider.create(this.root, {
			start: [+this.data.start, +this.data.finish],
			connect: true,
			range: {
				'min': +this.data.min,
				'max': +this.data.max
			}
		});
	}
}